import { useQuery } from "@apollo/client";
import { withErrorBoundary } from "@sentry/react";
import {
  GetAskAiMeetingEmbedQueryQuery,
  GetAskAiMeetingEmbedQueryQueryVariables,
} from "types/graphql-schema";

import ErrorFallback from "@components/error-fallback/error-fallback";
import { TopicflowIcon } from "@components/topicflow-icon/topicflow-icon";
import useDebounce from "@components/use-debounce/use-debounce";

import getAskAiMeetingEmbedQuery from "../graphql/get-ask-ai-meeting-embed-query";
import { askAIPlaceholderDebounceTime } from "../helpers";
import AskAIEmbedMeeting from "./ask-ai-embed-meeting";

const AskAIPlaceholderMeetingComponent = ({ id }: { id: number | null }) => {
  const { data } = useQuery<
    GetAskAiMeetingEmbedQueryQuery,
    GetAskAiMeetingEmbedQueryQueryVariables
  >(getAskAiMeetingEmbedQuery, {
    variables: { meetingId: id || 0 },
    skip: !id,
  });
  const meeting = data?.meeting;
  const hasMeeting = !!meeting;
  const debouncedHasMeeting = useDebounce(
    hasMeeting,
    askAIPlaceholderDebounceTime,
  );
  return debouncedHasMeeting && meeting ? (
    <AskAIEmbedMeeting meeting={meeting} />
  ) : (
    <div className="flex gap-3 items-center">
      <TopicflowIcon type="meeting" className="w-4 h-4 text-gray-500" />
      <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-6 flex-1" />
      <div className="text-gray-500 bg-gray-100 animate-pulse rounded-md h-6 w-24" />
    </div>
  );
};

const AskAIPlaceholderMeetingWithSentry = withErrorBoundary(
  AskAIPlaceholderMeetingComponent,
  {
    fallback: ErrorFallback,
  },
);

export default AskAIPlaceholderMeetingWithSentry;
